import styled from 'styled-components';

import TextInput from '../../inputs/TextInput';

export const StyledTextInput = styled(TextInput)`
  margin: 1.5em 0;
`;
